import { email, required } from "vuelidate/lib/validators";

export const validations = {
  formData: {
    company: {
      required
    },
    name: {
      required
    },
    streetNr: {
      required
    },
    zipCity: {
      required
    },
    phone: {},
    fax: {},
    email: {
      required,
      email
    },
    message: {
      required
    }
  }
};

const formData = {
  company: "",
  name: "",
  streetNr: "",
  zipCity: "",
  phone: "",
  fax: "",
  email: "",
  message: ""
};

export const initialState = {
  formData,
  previousData: {},
  isSubmitted: false,
  formSubmitSwitch: false,
  executeSwitch: false,
  serverError: false,
  contactTitle: undefined,
  contactBack: false
};
